    <div class="card">
         <div class="user-heading-sec">
            <p>{{this.total}} Posts</p> 

            <nav class="navbar-collapse" style="border: none;">
              <div style='width: 120px'>
                <a data-toggle="collapse" href="#postEdit" 
                    class="fa fa-address-book btn btn-default ">
                    Add Post
                </a>                        
              </div>       
              <div id="postEdit" class="collapse">
                    <app-post [parent_id]="this.parent_id" [id]="0" (submitted)="collapseMe()"></app-post>
              </div>                   
            </nav>
        </div>
        <div class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>
                            {{header.text}}
                        </th>
                      <th>Action</th>
                    </tr>
                    <tr>
                        <th>&nbsp;
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByPost($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let post of posts">
                        <tr>                  
                            <td>
                                <a data-toggle="collapse" href="#postEdit{{post.ID}}">
                                    {{post.Order}}
                                </a>
                            </td>    
                            <td>
                                <a data-toggle="collapse" href="#postEdit{{post.ID}}">{{post.Name}}</a>
                            </td>
                            <td>
                                <a data-toggle="collapse" href="#postEdit{{post.ID}}">{{post.Body.substring(0,50)}}</a>
                            </td>
                            
                            <td>
                                <div ngbDropdown placement="bottom-right" class="d-inline-block">
                                    <button class="" id="dropdownBasic1" ngbDropdownToggle><i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button class="dropdown-item" (click)="deletePost(post.ID)">Delete</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div id="postEdit{{post.ID}}" class="collapse">
                                    <app-post [id]="post.ID" [parent_id]="this.parent_id" [parent_name]="this.parent_name"
                                      (submitted)="collapseMe()"></app-post>
                                </div>
                            </td>
                        </tr>
                        <tr></tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="posts?.length == 0">
                  <tr><td colspan="3">No Result Found</td></tr>
                </ng-container>


            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
